// frontend-react/src/components/sales/PillToggle.jsx
import React, { memo } from 'react';

export default memo(function PillToggle({ value, onChange, options }) {
  return (
    <div className="inline-flex rounded-xl border bg-surface-primary p-1">
      {options.map(opt => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange?.(opt.value)}
            className={[
              'px-3 py-1.5 text-sm rounded-lg transition',
              active ? 'bg-surface-card shadow-sm border' : 'text-content-secondary hover:text-content-primary',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
});
